// react
import PropTypes from "prop-types";
import React from "react";

// style
import "./style.scss";

export default class ModalWrapper extends React.Component {
	static propTypes = {
		children: PropTypes.node.isRequired,
	};

	static defaultProps = {};

	render() {
		const { children } = this.props;

		return (
			<div className="cp-modal-wrapper">
				<div className="inner-wrapper">
					<div>{children}</div>
				</div>
			</div>
		);
	}
}
